var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [(_vm.displayMsg == 'success') ? _c('b-alert', {
    staticClass: "success-display-none",
    attrs: {
      "show": "",
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.successErrorMsg))]) : _vm._e(), _vm._v(" "), (_vm.displayMsg == 'error') ? _c('b-alert', {
    staticClass: "danger-display-none",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.successErrorMsg))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('importCsv.NfDateForm')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('importCsv.NFDateTo')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('importCsv.NfRackID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cubes'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('rackid')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.rackIDPlaceholder'),
      "name": "rackid",
      "id": "rackid"
    },
    model: {
      value: (_vm.rackid),
      callback: function($$v) {
        _vm.rackid = $$v
      },
      expression: "rackid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('importCsv.NfSku')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-product-hunt'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('productid')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('importCsv.NfSku'),
      "name": "productid",
      "id": "productid"
    },
    model: {
      value: (_vm.productid),
      callback: function($$v) {
        _vm.productid = $$v
      },
      expression: "productid"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.notfoundListingsearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetAuditSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.reset')))])])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row expand",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-3 s2 o1 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('importCsv.NotFound')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 s2 o2 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('product.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 s1 o3 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('product.table.count')) + " - " + _vm._s(this.totalRows))])]), _vm._v(" "), _c('div', {
    staticClass: " cardlistheader"
  }, [_c('loader', {
    staticStyle: {
      "margin-right": "-400px"
    },
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticStyle: {
      "width": "130px",
      "height": "30px",
      "margin-left": "-12px",
      "margin-bottom": "8px"
    },
    attrs: {
      "id": "openbtn"
    },
    on: {
      "click": function($event) {
        _vm.notfoundListingsearch('open')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lpnmaster.open')) + ": (" + _vm._s(this.totalopenRows) + ")")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "130px",
      "height": "30px",
      "margin-left": "-12px",
      "margin-bottom": "8px"
    },
    attrs: {
      "id": "closebtn"
    },
    on: {
      "click": function($event) {
        _vm.notfoundListingsearch('closed')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lpnmaster.closed')) + ": (" + _vm._s(this.totalcloseRows) + ")")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('importCsv.nfiD')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('importCsv.NfDateTime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('importCsv.NfByUserId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('importCsv.NFRackID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('importCsv.NfSku')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])])])]), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('editedjson.noDataFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listAuditData), function(data) {
    return [_c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', {
      class: {
        opened: _vm.opened.includes(data.rackid)
      },
      staticStyle: {
        "padding": "5px",
        "color": "#0000e5",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showRow(data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-chevron-down",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(data.createddate)) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rackid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.nfqty))])]), _vm._v(" "), (data.contentVisible && _vm.contentVisible) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": 13
      }
    }, [_c('fieldset', {
      staticStyle: {
        "padding": "10px 0 0 0"
      }
    }, [_c('div', {
      staticClass: "col-14"
    }, [_c('b-tabs', [_c('b-tab', {
      attrs: {
        "title": _vm.$t('importCsv.nfCycleCount')
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between"
      }
    }, [_c('div', {
      staticClass: "cyclecount-info-container"
    }, [(!_vm.isuserAssigned && !data.assignedto) ? _c('div', {
      staticClass: "cyclecount-info"
    }, [_c('div', {
      staticClass: "info-block"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v(_vm._s(_vm.$t('importCsv.NFCyclecountID')) + " :")]), _vm._v(" "), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(_vm.nfCyclecountId))])]), _vm._v(" "), _c('div', {
      staticClass: "info-block"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v(_vm._s(_vm.$t('importCsv.nfActivityId')) + " :")]), _vm._v(" "), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(_vm.nfActivityId))])]), _vm._v(" "), _c('div', {
      staticClass: "info-block"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v(_vm._s(_vm.$t('importCsv.NFCyclecountCreatedDate')) + " :")]), _vm._v(" "), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(_vm.nfCyclecountCreatedDate || 'N/A'))])]), _vm._v(" "), _c('div', {
      staticClass: "info-block"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v(_vm._s(_vm.$t('importCsv.NFCyclecountCompletedDate')) + " :")]), _vm._v(" "), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(_vm.nfCyclecountCompletedDate || 'N/A'))])]), _vm._v(" "), _c('div', {
      staticClass: "info-block"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v(_vm._s(_vm.$t('importCsv.NFCyclecountCompletedBy')) + " :")]), _vm._v(" "), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(_vm.nfCyclecountCompletedBy || 'N/A'))])])]) : _vm._e(), _vm._v(" "), (_vm.isuserAssigned || data.assignedto) ? _c('div', {
      staticClass: "cyclecount-info"
    }, [_c('div', {
      staticClass: "info-block"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v(_vm._s(_vm.$t('importCsv.NFCyclecountID')) + " :")]), _vm._v(" "), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(_vm.nfCyclecountId))])]), _vm._v(" "), _c('div', {
      staticClass: "info-block"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v(_vm._s(_vm.$t('importCsv.nfActivityId')) + " :")]), _vm._v(" "), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(_vm.nfActivityId))])]), _vm._v(" "), _c('div', {
      staticClass: "info-block"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v(_vm._s(_vm.$t('common.assignedTo')) + " :")]), _vm._v(" "), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(_vm.Assignedto || 'N/A'))])]), _vm._v(" "), _c('div', {
      staticClass: "info-block"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v(_vm._s(_vm.$t('common.createdDate')) + " :")]), _vm._v(" "), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(_vm.nfCyclecountCreatedDate || 'N/A'))])]), _vm._v(" "), _c('div', {
      staticClass: "info-block"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v(_vm._s(_vm.$t('importCsv.NFCyclecountCompletedDate')) + " :")]), _vm._v(" "), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(_vm.nfCyclecountCompletedDate || 'N/A'))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "assign-section"
    }, [(!data.assignedto && !_vm.isuserAssigned) ? _c('div', {
      staticClass: "col-md-3"
    }, [_c('b-input-group', {
      attrs: {
        "left": "<i class='fa fa-window-maximize'></i>"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.pickeruser),
        expression: "pickeruser"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "name": "pickerid"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.pickeruser = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.disableassign = false
        }]
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "value": ""
      }
    }, [_vm._v(_vm._s(_vm.$t('importCsv.AssignCyclecount')))]), _vm._v(" "), _vm._l((_vm.pickerListData), function(user_obj) {
      return _c('option', {
        domProps: {
          "value": user_obj.userid
        }
      }, [_vm._v(_vm._s(user_obj.email))])
    })], 2)])], 1) : _vm._e(), _c('br'), _vm._v(" "), (!data.assignedto && !_vm.isuserAssigned) ? _c('div', {
      staticClass: "col-md-3"
    }, [_c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "disabled": _vm.disableassign
      },
      on: {
        "click": _vm.assignedUserNf
      }
    }, [_vm._v(_vm._s(_vm.$t('importCsv.AssignUser')) + "\n                                  ")])]) : _vm._e(), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "disabled": _vm.disableviewvariance
      },
      on: {
        "click": function($event) {
          _vm.getVariance(data)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('importCsv.ViewCyclecountvariance')))])])])])]), _vm._v(" "), _c('b-tab', {
      attrs: {
        "title": _vm.$t('importCsv.NFStockAllocation')
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between"
      }
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('div', {
      staticClass: "info-block"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v(_vm._s(_vm.$t('importCsv.NfSku')) + " :")]), _vm._v(" "), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(_vm.nfeancode))])]), _vm._v(" "), _c('div', {
      staticClass: "info-block"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v(_vm._s(_vm.$t('warehouseRacks.rackId')) + " :")]), _vm._v(" "), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(_vm.nfrackid))])]), _vm._v(" "), _c('div', {
      staticClass: "info-block"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v(_vm._s(_vm.$t('importCsv.allocationtime')) + " :")]), _vm._v(" "), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(_vm.allocationtimeNf || 'N/A'))])]), _vm._v(" "), _c('div', {
      staticClass: "info-block"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v(_vm._s(_vm.$t('importCsv.NFCyclecountCompletedBy')))]), _vm._v(" "), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(_vm.nfCyclecountCompletedBy || 'N/A'))])])])])])], 1)], 1)])])]) : _vm._e()]
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.popupOpen),
      callback: function($$v) {
        _vm.popupOpen = $$v
      },
      expression: "popupOpen"
    }
  }, [_c('div', {
    staticClass: "col-md-8",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "rgb(0, 0, 0)",
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$t('importCsv.CycleCountVariance')))])])]), _vm._v(" "), _c('b-tabs', [_c('b-tab', {
    attrs: {
      "title": _vm.getTabTitle('short', _vm.Shortdata)
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "col-md-13"
  }, [_c('h7', [_vm._v(_vm._s(_vm.$t('importCsv.CycleCountID')) + ": " + _vm._s(_vm.nfCyclecountId))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "margin-top": "15px"
    }
  }, [_c('table', {
    staticClass: "table-container",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "scroll-container"
  }, [_c('table', [_c('thead', [_c('tr', {
    staticClass: "text-primary "
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('importCsv.SKU(EAN)')) + " ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('auditReport.systemQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('importCsv.CycleCountQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('importCsv.diffrenceBetweenQty')) + " ")])])])]), _vm._v(" "), _c('tbody', [(_vm.Shortdata.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.Shortdata), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center ",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(data.eancode))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.rackstock))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(Math.abs(data.rackstock - data.qty)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.qty))])])
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "float-right",
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.popupOpen = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.close')))])])], 1)])], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.getTabTitle('excess', _vm.excessData)
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "col-md-13"
  }, [_c('h7', [_vm._v(_vm._s(_vm.$t('importCsv.CycleCountID')) + ": " + _vm._s(_vm.nfCyclecountId))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "margin-top": "15px"
    }
  }, [_c('table', {
    staticClass: "table-container",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "scroll-container"
  }, [_c('table', [_c('thead', [_c('tr', {
    staticClass: "text-primary "
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('importCsv.SKU(EAN)')) + " ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('auditReport.systemQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('importCsv.CycleCountQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('importCsv.diffrenceBetweenQty')) + " ")])])])]), _vm._v(" "), _c('tbody', [(_vm.excessData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.excessData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center ",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(data.eancode))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.rackstock))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(Math.abs(data.rackstock + data.qty)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.qty))])])
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "float-right",
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.popupOpen = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.close')))])])], 1)])], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.getTabTitle('extra', _vm.Extradata)
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "col-md-13"
  }, [_c('h7', [_vm._v(_vm._s(_vm.$t('importCsv.CycleCountID')) + ": " + _vm._s(_vm.nfCyclecountId))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "margin-top": "15px"
    }
  }, [_c('table', {
    staticClass: "table-container",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "scroll-container"
  }, [_c('table', [_c('thead', [_c('tr', {
    staticClass: "text-primary "
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('importCsv.SKU(EAN)')) + " ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('auditReport.systemQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('importCsv.CycleCountQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('importCsv.diffrenceBetweenQty')) + " ")])])])]), _vm._v(" "), _c('tbody', [(_vm.Extradata.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.Extradata), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center ",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(data.eancode))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.rackstock))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(Math.abs(data.rackstock + data.qty)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.qty))])])
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "float-right",
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.popupOpen = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('packingb2b.b2bPacking.modal.close')))])])], 1)])], 1)], 1)], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-34ee3f2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34ee3f2e","hasScoped":true}!./src/views/components/notfound/NotFound.component.html
// module id = 2131
// module chunks = 0